import { render, staticRenderFns } from "./searchPage.vue?vue&type=template&id=c9e70470&scoped=true&"
import script from "./searchPage.vue?vue&type=script&lang=js&"
export * from "./searchPage.vue?vue&type=script&lang=js&"
import style0 from "./searchPage.vue?vue&type=style&index=0&id=c9e70470&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9e70470",
  null
  
)

export default component.exports